import React, { useImperativeHandle, forwardRef, useState, useRef, useEffect, useMemo } from "react";
import { Card, CardBody, Col, Container, Row, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap";
import { CascadeSelect } from 'primereact/cascadeselect';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from 'primereact/fileupload';
import { InputText } from "primereact/inputtext";
import { Toast } from 'primereact/toast';
import axios from 'axios';
import { useSelector,useDispatch } from "react-redux";
import { setPageData } from "store/actions";

const MoreACcontacts = forwardRef(({ selectedCustomers, getallactivecontacts, updateSelectedCustomers, selectedStatusforhide}, ref) => {
    const [changeStatusAction, setChangeStatusAction] = useState(false);
    const [isAttachDocumentVisible, setIsAttachDocumentVisible] = useState(false);
    const [selectedLinkJob, setSelectedLinkJob] = useState(null);
    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [docSubject, setDocSubject] = useState("");
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [hasFileError, setHasFileError] = useState(false);
    const toast = useRef(null);
    const fileUploadRef = useRef(null);
    const dispatch = useDispatch();
    const { first, rows } = useSelector(state => state.calendar.pagination);
    

    const moreoptions = useMemo(() => {
        if (selectedStatusforhide !== 'Active') {
            return [
                {
                    name: "Change Status",
                    onClick: () => {
                        if(selectedCustomers.length > 0 ){
                             setChangeStatusAction(true)
                        }else{
                            setWarningDialogueVisible(true);
                        }
                    }
                }
            ];
        }
        
        return [
            {
                name: "Attachments",
                onClick: () => {
                    if(selectedCustomers.length > 0 ){
                        setIsAttachDocumentVisible(true);
                    }
                    else{
                        setWarningDialogueVisible(true);
                    }
                }
            },
            {
                name: "Change Status",
                onClick: () => {
                    if(selectedCustomers.length > 0 ){
                         setChangeStatusAction(true)
                    }else{
                        setWarningDialogueVisible(true);
                    }
                }
            },
        ];
    }, [selectedStatus, selectedCustomers.length]);

    useImperativeHandle(ref, () => ({
        openAttachments: () => {
            if(selectedCustomers.length > 0 ){
                setIsAttachDocumentVisible(true);
            }
            else{
                setWarningDialogueVisible(true);
            }},
        openChangeStatus: () => {
            if(selectedCustomers.length > 0 ){
                 setChangeStatusAction(true)
            }else{
                setWarningDialogueVisible(true);
            }}
    }));
    useEffect(() => {
    if (isAttachDocumentVisible) {
        fetchDocuments();
    }
}, [isAttachDocumentVisible]);

    const [documentTypes, setDocumentTypes] = useState([]);

    const fetchDocuments = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-document-type/`);
            const transformed = response.data.results.map((doc) => ({
                label: doc.value, 
                value: doc.id
            }));
            setDocumentTypes(transformed);
        } catch (error) {
            console.error("Error fetching documents:", error);
        }
    };

    

    const statusOptions = [
        { id: 1, label: "Active", value: "Active" },
        { id: 2, label: "InActive", value: "InActive" },
        { id: 3, label: "DND (Do Not Disturb)", value: "DND (Do Not Disturb)" },
        { id: 4, label: "Blacklisted", value: "Blacklisted" },
    ];

    const onUpload = (event) => {
        const allowedExtensions = ['.pdf', '.docx', '.jpg', '.jpeg', '.png'];
        const files = Array.from(event.files);

        const invalidFiles = files.filter(file => {
            const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
            return (
                file.size > 2000000 ||
                !allowedExtensions.includes(fileExtension)
            );
        });

        if (invalidFiles.length > 0) {
            const errorMessages = invalidFiles.map(file => {
                const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
                if (file.size > 2000000) {
                    return `File ${file.name} exceeds the 2MB limit.`;
                } else if (!allowedExtensions.includes(fileExtension)) {
                    return `File ${file.name} is not an allowed file type. Allowed types are: ${allowedExtensions.join(', ')}.`;
                }
            });

            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: errorMessages.join(' '),
                life: 3000
            });

            setHasFileError(true);
            if (fileUploadRef.current) {
                fileUploadRef.current.clear();
            }

            return;
        }

        setHasFileError(false);
        setUploadedFiles(files);
    };

    const onRemove = (event) => {
        const fileToRemove = event.file;
        setUploadedFiles((prevFiles) => prevFiles.filter(file => file.name !== fileToRemove.name));
    };

    const onClear = () => {
        setUploadedFiles([]);
    };

    const resetFormFields = () => {
        setSelectedDocumentType(null);
        setDocSubject("");
        setUploadedFiles([]);
        setHasFileError(false);
    };

    const isSubmitDisabled = !selectedDocumentType || !docSubject || uploadedFiles.length === 0 || hasFileError || isSubmitting;

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result.split(',')[1];
                if (!base64String) {
                    reject(new Error('Failed to encode file to Base64'));
                }
                resolve({
                    file_name: file.name,
                    file_data: base64String,
                });
            };
            reader.onerror = (error) => reject(error);
        });
    };

    const handleCreateDocument = async () => {
        if (hasFileError) {
            return;
        }
        
        setIsSubmitting(true);
        if (selectedCustomers.length === 0) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Select a contact to create document',
                life: 3000
            });
            setIsSubmitting(false);
            return;
        }

        if (!selectedDocumentType || !docSubject || uploadedFiles.length === 0) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Please select document type, enter subject and upload file',
                life: 3000
            });
            setIsSubmitting(false);
            return;
        }

        try {
            const attachments = await Promise.all(
                uploadedFiles.map(async (file) => {
                    try {
                        return await fileToBase64(file);
                    } catch (error) {
                        throw new Error(`Failed to process file ${file.name}: ${error.message}`);
                    }
                })
            );
            const payload = {
                document_type: selectedDocumentType,
                document_subject: docSubject,
                contact_id: selectedCustomers[0].id,
                attachments,
            };
            const response = await axios.post(
                `/api/v1/documents/`,
                payload,
            );

            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Document created successfully',
                life: 3000
            });

            resetFormFields();
            setUploadedFiles([]);
            setIsAttachDocumentVisible(false);

        } catch (error) {
            console.error('Error creating document:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: error.response?.data?.message || 'Failed to create document',
                life: 3000
            });
            resetFormFields();
        } finally {
            setIsSubmitting(false);
        }
    };

    // const handleChangeStatus = async () => {
    //     if (!selectedStatus) {
    //         toast.current.show({
    //             severity: 'error',
    //             summary: 'Error',
    //             detail: 'Please select a status',
    //             life: 3000
    //         });
    //         return;
    //     }

    //     if (selectedCustomers.length === 0) {
    //         toast.current.show({
    //             severity: 'error',
    //             summary: 'Error',
    //             detail: 'No contacts selected',
    //             life: 3000
    //         });
    //         return;
    //     }

    //     try {
    //         const contactIds = selectedCustomers.map(customer => customer.id).join(',');
    //         const response = await axios.patch(`/api/v1/contacts/${contactIds}/change-status/`,
    //             {
    //                 status: selectedStatus
    //             }
    //         );
    //         const updatedCustomers = selectedCustomers.map((customer) => ({
    //             ...customer,
    //             status: selectedStatus,
    //         }));

    //         updateSelectedCustomers(updatedCustomers);
    //         toast.current.show({
    //             severity: 'success',
    //             summary: 'Success',
    //             detail: 'Contact status updated successfully',
    //             life: 3000
    //         });
    //         await getallactivecontacts(1, '', '', '');

    //         setChangeStatusAction(false);
    //         setSelectedStatus(null);

    //     } catch (error) {
    //         console.error('Error changing status:', error);
    //         toast.current.show({
    //             severity: 'error',
    //             summary: 'Error',
    //             detail: error.response?.data?.message || 'Failed to change status',
    //             life: 3000
    //         });
    //     }
    // };

    const handleChangeStatus = async () => {
    if (!selectedStatus) {
        toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: 'Please select a status',
            life: 3000
        });
        return;
    }

    if (selectedCustomers.length === 0) {
        toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: 'No contacts selected',
            life: 3000
        });
        return;
    }

    try {
        const contactIds = selectedCustomers.map(customer => customer.id).join(',');
        await axios.patch(`/api/v1/contacts/${contactIds}/change-status/`, {
            status: selectedStatus
        });

        // Show success toast only here
        toast.current.show({
            severity: 'success',
            summary: 'Success',
            detail: 'Contact status updated successfully',
            life: 3000
        });

        // Get current pagination from Redux
       
        const page = Math.floor(first / rows) + 1;

        // Reload data for the correct page and status
        await getallactivecontacts(page, '', '', null);

        setChangeStatusAction(false);
        setSelectedStatus(null);

    } catch (error) {
        toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: error.response?.data?.message || 'Failed to change status',
            life: 3000
        });
    }
};
    useEffect(() => {
        if (changeStatusAction && selectedCustomers.length > 0) {
            const currentStatus = selectedCustomers[0]?.status || "";
            setSelectedStatus(currentStatus);
        }
    }, [changeStatusAction, selectedCustomers]);

    const [warningDialogueVisible, setWarningDialogueVisible]= useState('');

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <CascadeSelect
                value={selectedLinkJob}
                onChange={(e) => {
                    if (e.value && e.value.onClick) {
                        e.value.onClick();
                    }
                }}
                options={moreoptions}
                optionLabel="name"
                optionGroupLabel="name"
                optionGroupChildren={["jobs"]}
                placeholder="More"
                className="ms-2 me-1"
            />

            <Dialog
                header="Change Status"
                visible={changeStatusAction}
                onHide={() => {
                    setChangeStatusAction(false);
                    setSelectedStatus("");
                }}
                style={{ width: '400px' }}
                className="changestatus-popup"
            >
                <Row className="mt-2 align-items-center">
                    <Col md={2}>
                        <label className="status-label mb-2">
                            Status
                        </label>
                    </Col>
                    <Col md={10}>
                        <Dropdown
                            value={selectedStatus}
                            onChange={(e) => setSelectedStatus(e.value)}
                            options={statusOptions}
                            optionLabel="label"
                            placeholder="Select Status"
                            className="w-full"
                        />
                    </Col>
                </Row>
                <div className="d-flex justify-content-end mt-4">
                    <button
                        className="btn btn-primary btn-main mt-2"
                        onClick={handleChangeStatus}
                    >
                        Submit
                    </button>
                </div>
            </Dialog>

            <Dialog
                header="Attachments"
                visible={isAttachDocumentVisible}
                onHide={() => {setIsAttachDocumentVisible(false); resetFormFields();}}
                style={{ width: '45vw' }}
                breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            >
                <Row className="align-items-center">
                    <Col xl={6}>
                        <div className="card flex justify-content-center mb-0 border-0">
                            <label className="block mb-2">
                                Document Type<span style={{ color: "red" }}>*</span>
                            </label>
                            <Dropdown
                                value={selectedDocumentType}
                                onChange={(e) => setSelectedDocumentType(e.value)}
                                options={documentTypes}
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Select a Document Type"
                                className="w-full bgclr"
                            />
                        </div>
                    </Col>

                    <Col lg={6}>
                        <div className="p-field mt-2">
                            <label htmlFor="docSubject" className="block">Document Subject<span style={{ color: "red" }}>*</span></label>
                            <InputText
                                id="docSubject"
                                value={docSubject}
                                onChange={(e) => setDocSubject(e.target.value)}
                                placeholder="Enter Document Subject"
                                className="p-inputtext-sm w-full"
                            />
                        </div>
                    </Col>

                    <Col lg={12}>
                        <div className="card flex justify-content-center mb-0 border-0 mt-2">
                            <label className="block mb-2">
                                Attach Documents<span style={{ color: "red" }}>*</span>
                            </label>
                            <FileUpload
                                ref={fileUploadRef}
                                name="demo[]"
                                accept=".doc,.docx,.pdf,.jpg,.jpeg,.png, .xls,.csv"
                                maxFileSize={10000000}
                                customUpload
                                auto
                                onSelect={onUpload}
                                onRemove={onRemove}
                                onClear={onClear}
                                multiple
                                emptyTemplate={<p className="m-0">Drag and drop files to here to upload.</p>}
                                itemTemplate={(file, props) => {
                                    // Format the size in KB
                                    const sizeInKB = (file.size / 1024).toFixed(2) + ' KB';

                                    return (
                                        <div className="w-full flex justify-content-between p-2 border-round-sm">
                                            <div>
                                                <div>{file.name}</div>
                                                <small>{sizeInKB}</small>
                                            </div>
                                            <Button
                                                icon="pi pi-times"
                                                className="p-button-rounded p-button-text"
                                                onClick={() => props.onRemove(file)}
                                            />
                                        </div>
                                    );
                                }}
                            />
                            <small className="text-muted">
                                Note: Maximum file size is 2MB. Allowed formats: PDF, DOCX, JPEG, PNG, JPG.
                            </small>
                        </div>
                    </Col>
                    <Col lg={12}>
                        <button
                            className="btn btn-primary btn-main mt-2"
                            onClick={handleCreateDocument}
                            disabled={isSubmitDisabled}
                        >
                            {isSubmitting ? 'Submitting' : 'Submit'}
                        </button>
                    </Col>
                </Row>
            </Dialog>
            <Dialog
                header="Warning"
                visible={warningDialogueVisible}
                modal
                onHide={() => setWarningDialogueVisible(false)}
                style={{ width: "30vw" }}
                className="modal-content"
            >
                <div className="p-3">
                    <p>Please select at least one Contact to proceed.</p>
                    <div className="d-flex justify-content-end mt-4">
                        <Button
                            type="button"
                            label="OK"
                            className="btn btn-primary btn-main"
                            onClick={() => setWarningDialogueVisible(false)}
                        />
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    );
});

export default MoreACcontacts;